import React, { useEffect, useState } from 'react';
import { Grid, Button, Box } from "@mui/material";
import { styles } from "./styles";
import { styles as inputStyles } from "common/inputStyles";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { CSVLink } from "react-csv";
import { Colors } from "assets/colors";

interface ActionButtons {
  label: string;
  icon?: any;
  onClickHandler: Function;
  buttonStyle: any;
}

interface TableHeaderProps {
  actionButtons: Array<ActionButtons>;
  searchVal: string;
  setSearchVal: Function;
  data: any;
  tabs?: Array<ActionButtons>;
  withFilter?: boolean;
  csvLabel?: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({ actionButtons, searchVal, setSearchVal, data, tabs, withFilter, csvLabel }) => {
  const [checkedData, setCheckedData] = useState<any>(null);
  const [transformed, setTransformed] = useState(false);
  const [formattedData, setFormattedData] = useState<any>(null);


  const transformUserRoles = (arr: any) =>  {
    let transformedArray: any = [];
    arr.forEach((obj: any) => {
      if (obj.hasOwnProperty('userRoleList')) {
        let transformedObj = {...obj};
        if (transformedObj.hasOwnProperty('userId')) {
          delete transformedObj['userId'];
        }
        if (transformedObj.hasOwnProperty('timeZone')) {
          delete transformedObj['timeZone'];
        }
        if (transformedObj.hasOwnProperty('dateFormat')) {
          delete transformedObj['dateFormat'];
        }
        if (transformedObj.hasOwnProperty('numberFormat')) {
          delete transformedObj['numberFormat'];
        }
        if (transformedObj.hasOwnProperty('permissionCount')) {
          delete transformedObj['permissionCount'];
        }
        if (transformedObj.hasOwnProperty('roleId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        const userRoles = transformedObj['userRoleList'].map((roleObj: any) => roleObj['roleName']);
        transformedObj['userRoleList'] = userRoles.join(', ');
        transformedArray.push(transformedObj);
        //console.log(transformedObj)
      }
    });
   
    if(transformedArray.length > 0) {
      setCheckedData(transformedArray);
    } else {
      setCheckedData(data);
    }
  }

  const transformKey = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const transformObjectKeys = (obj: any) => {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      const transformedKey = transformKey(key);
      return { ...acc, [transformedKey]: obj[key] };
    }, {});
    return transformedObj;
  };

  useEffect(() => {
    if(checkedData !== null && checkedData.length > 0) {
      let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
     console.log(transformedArray)
      let trucks:any = [];
      for(var i=0;i<transformedArray.length;i++){
        //console.log(transformedArray[i].hasOwnProperty("Role Id"));

        if(transformedArray[i].hasOwnProperty("Iot Device Id")){
          delete transformedArray[i]["Iot Device Id"];
        }
        if(transformedArray[i].hasOwnProperty("Is Camera Connected")){
          delete transformedArray[i]["Is Camera Connected"];
        }
        if(transformedArray[i].hasOwnProperty("Role Id")){
          delete transformedArray[i]["Role Id"];
        }
        if(transformedArray[i].hasOwnProperty("Truck Id")){
          transformedArray[i]["Truck Id"] = transformedArray[i]["Truck Name"];
        }
        if(transformedArray[i].hasOwnProperty("Warehouse Location NAme")){
          transformedArray[i]["Warehouse Location"] = transformedArray[i]["Warehouse Location NAme"];
        }
        if(transformedArray[i].hasOwnProperty("Warehouse Location NAme")){
          delete transformedArray[i]["Warehouse Location NAme"];
        }
        if(transformedArray[i].hasOwnProperty("Sf Id")){
          delete transformedArray[i]["Sf Id"];
        }
        if(transformedArray[i].hasOwnProperty("Time Zone")){
          delete transformedArray[i]["Time Zone"];
        }
        if(transformedArray[i].hasOwnProperty("Truck Name")){
          delete transformedArray[i]["Truck Name"];
        }
        if(transformedArray[i].hasOwnProperty("Tag Scheme Id")){
          delete transformedArray[i]["Tag Scheme Id"];
        }
        
        let truckkObj:any = {};

        // Tag Scheme Manager - Download CSV Labels
        if(transformedArray[i]["Tag Scheme Name"] !== undefined)
          truckkObj["Tag Scheme Name"] = transformedArray[i]["Tag Scheme Name"];
        if(transformedArray[i]["Tag Scheme Status"] !== undefined)
          truckkObj["Tag Scheme Status"] = transformedArray[i]["Tag Scheme Status"];
        if(transformedArray[i]["Description"] !== undefined)
          truckkObj["Description"] = transformedArray[i]["Description"];
        if(transformedArray[i]["Tag Scheme Length"] !== undefined)
          truckkObj["Tag Scheme Length"] = transformedArray[i]["Tag Scheme Length"];
        if(transformedArray[i]["Header Format"] !== undefined)        
          truckkObj["Header Format"] = transformedArray[i]["Header Format"];
        if(transformedArray[i]["Header Length"] !== undefined)
          truckkObj["Header Length"] = transformedArray[i]["Header Length"];
        if(transformedArray[i]["Header Id"] !== undefined)
          truckkObj["Header Id"] = transformedArray[i]["Header Id"];
        if(transformedArray[i]["Serial Number Format"] !== undefined)
          truckkObj["Serial Number Format"] = transformedArray[i]["Serial Number Format"];
        if(transformedArray[i]["Serial Number Length"] !== undefined)
          truckkObj["Serial Number Length"] = transformedArray[i]["Serial Number Length"];
        if(transformedArray[i]["Serial Number Id"] !== undefined)
          truckkObj["Serial Number Id"] = transformedArray[i]["Serial Number Id"];
        
        // User Management - Users - Download CSV Labels
        if(transformedArray[i]["Email"] !== undefined)
          truckkObj["Email"] = transformedArray[i]["Email"];
        if(transformedArray[i]["First Name"] !== undefined)
          truckkObj["First Name"] = transformedArray[i]["First Name"];
        if(transformedArray[i]["Last Name"] !== undefined)
          truckkObj["Last Name"] = transformedArray[i]["Last Name"];
        if(transformedArray[i]["Phone Number"] !== undefined)
          truckkObj["Phone Number"] = transformedArray[i]["Phone Number"];
        if(transformedArray[i]["User Status"] !== undefined)
          truckkObj["User Status"] = transformedArray[i]["User Status"];
        
        // User Management - Roles -Download CSV Labels
        if(transformedArray[i]["Role Name"] !== undefined)
          truckkObj["Role Name"] = transformedArray[i]["Role Name"];
        if(transformedArray[i]["Application Name"] !== undefined)
          truckkObj["Application Name"] = transformedArray[i]["Application Name"];
        if(transformedArray[i]["Role Status"] !== undefined)
          truckkObj["Role Status"] = transformedArray[i]["Role Status"];
        if(transformedArray[i]["Role Description"] !== undefined)
          truckkObj["Role Description"] = transformedArray[i]["Role Description"];

         // Comman Fields - Download CSV Labels
        if(transformedArray[i]["Creation Date"] !== undefined)
          truckkObj["Creation Date"] = transformedArray[i]["Creation Date"];
        if(transformedArray[i]["Created By"] !== undefined)
          truckkObj["Created By"] = transformedArray[i]["Created By"];
        if(transformedArray[i]["Last Update Date"] !== undefined)
          truckkObj["Last Updated Date"] = transformedArray[i]["Last Update Date"];
        if(transformedArray[i]["Last Updated By"] !== undefined)
          truckkObj["Last Updated By"] = transformedArray[i]["Last Updated By"];
        
        // User Management - Users - Download CSV Labels
        if(transformedArray[i]["User Role List"] !== undefined)
          truckkObj["User Role List"] = transformedArray[i]["User Role List"];
        
        // User Management - Roles -Download CSV Labels
        if(transformedArray[i]["Permission Count"] !== undefined)
          truckkObj["Permission Count"] = transformedArray[i]["Permission Count"];
        
        trucks.push(truckkObj);
      }
      setFormattedData(trucks);
    }
  }, [checkedData]);

  useEffect(() => {
    if(data.length > 0) {
      transformUserRoles(data);
    }
  }, [data]);

  return (
    <Grid item xs={12} sx={{ ...styles.container, justifyContent: tabs ? "space-between" : "flex-end" }}>
      {
        tabs &&
        <Grid sx={styles.buttonContainer}>
          {tabs.map((t, i) =>
            <Button key={i} sx={{ ...styles.buttons, ...t.buttonStyle, marginRight: 0 }} onClick={() => t.onClickHandler()}>
              {t.icon && t.icon}
              {t.label}
            </Button>
          )}
        </Grid>
      }
      <Grid sx={styles.buttonContainer}>
        {actionButtons.map((b, i) =>
          <Button key={i} sx={{ ...styles.buttons, ...b.buttonStyle }} onClick={() => b.onClickHandler()}>
            {b.icon && b.icon}
            {b.label}
          </Button>
        )}
        <CSVLink data={formattedData || []} style={{ textDecoration: 'none' }} filename={csvLabel ? csvLabel: 'download.csv'}>
          <Button sx={{ ...styles.buttons, backgroundColor: Colors.Purple }}>
            <FileDownloadOutlinedIcon sx={{ marginRight: ".5rem" }} />
            Download CSV
          </Button>
        </CSVLink>
        <Box sx={inputStyles.searchContainer}>
          <SearchOutlinedIcon sx={{ marginLeft: ".5rem" }} />
          <input type="text" placeholder='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
        </Box>
        {withFilter && <FilterAltIcon sx={styles.filterIcon} />}
      </Grid>

    </Grid>
  )
}

export default TableHeader;
